module.exports = __webpack_public_path__ + "img/activity_6_how_to_splash.a0a305d9.jpg";